import Learn from './Learn';

export default Learn;
